(() => {
  const root = document.querySelector('.cq-case-index');
  if (!root) return;
  const input = root.querySelector('#cq-case-search');
  const buttons = [...root.querySelectorAll('[data-case-filter]')];
  const items = [...root.querySelectorAll('.cq-case-item')];
  const status = root.querySelector('#cq-case-count');
  const empty = root.querySelector('.cq-case-empty');
  let category = 'all';
  const normal = text => text.toLocaleLowerCase('en-AU').normalize('NFKC').trim();
  function update() {
    const terms = normal(input.value).split(/\s+/).filter(Boolean);
    let visible = 0;
    for (const item of items) {
      const categoryMatch = category === 'all' || item.dataset.caseGroups.split(' ').includes(category);
      const text = normal(item.textContent);
      item.hidden = !categoryMatch || !terms.every(term => text.includes(term));
      if (!item.hidden) visible++;
    }
    for (const button of buttons) button.setAttribute('aria-pressed', String(button.dataset.caseFilter === category));
    status.textContent = visible === items.length ? `Showing all ${items.length} case studies` : `Showing ${visible} of ${items.length} case studies`;
    empty.hidden = visible !== 0;
  }
  buttons.forEach(button => button.addEventListener('click', () => { category = button.dataset.caseFilter; update(); }));
  input.addEventListener('input', update);
  root.querySelector('[data-case-reset]').addEventListener('click', () => {category = 'all'; input.value = ''; update(); input.focus();});
  update();
})();
